<template>
  <div class="page">
    <Header>
      <template #title>
        <span>リトル・ママオンラインフェスタ</span>
        抽選会プレゼント一覧
      </template>
    </Header>
    <div class="presents-wrapper">
      <div class="inner">
        <Heading>
          <template #heading>
            豪華キーワード3つで当たる<br>
            豪華商品がこちら
          </template>
        </Heading>
        <div class="presents">
          <Present
            v-for="(present, index) in presents" :key="index"
            :present="present"
          />
        </div>
      </div>
    </div>
    <div class="inner">
      <Howto />
    </div>
    <Floating>
      <template #content>
        <div v-if="month === '202006'">
          <Button06 :month="month"/>
        </div>
        <div v-if="month === '202007'">
          <Button07 :month="month"/>
        </div>
        <div v-if="month === '202008'">
          <Button08 :month="month"/>
        </div>
        <div v-if="month === '202009'">
          <Button09sendai :month="month"/>
        </div>
      </template>
    </Floating>
  </div>
</template>

<script>
import Header from '@/components/organisms/202007/Header.vue'
import Heading from '@/components/atoms/Heading.vue'
import Present from '@/components/molecules/Present.vue'
import Howto from '@/components/organisms/Howto.vue'
import Floating from '@/components/molecules/Floating.vue'
import Button06 from '@/components/atoms/202006/Button.vue'
import Button07 from '@/components/atoms/202007/Button.vue'
import Button08 from '@/components/atoms/202008/Button.vue'
import Button09sendai from '@/components/atoms/202009sendai/Button.vue'

export default {
  name: 'present',
  components: {
    Header,
    Heading,
    Present,
    Howto,
    Floating,
    Button06,
    Button07,
    Button08,
    Button09sendai
  },
  data: () => ({
    presents: [
      {
        thumbnail: '/img/present07/01.png',
        name: 'パナソニック 空気清浄機 ~12畳 ホワイト F-PDP30-W',
        num: '1名',
        description: 'お部屋に充満するさまざまな生活臭をセンサーが見つけ、ニオイを取り除くニオイセンサ、ペットの毛や繊維など比較的大きな汚れを取り除くプレフィルター、ナノレベルの超微細な穴でニオイの元を吸着する活性炭を粒状したスーパーナノテク脱臭フィルター搭載。',
        company: 'パナソニック株式会社',
        url: 'https://panasonic.jp/airrich/products/f_pdp30.html'
      },
      {
        thumbnail: '/img/present07/02.png',
        name: 'Eufy RoboVac 11S (ロボット掃除機)',
        num: '1名',
        description: 'お部屋に合わせて様々な掃除モードを選択でき、掃除のタイミングも設定可能。一般的な電子レンジの動作時と同程度の静かさでの掃除を実現しました。約7.2cmの高さのEufy RoboVac 11Sは家具の下など手の届きにくい場所でもあなたの代わりに掃除します。超薄型でありながら、BoostIQテクノロジー搭載かつ最大1300Paの吸引力を繰り出すEufy RoboVac 11Sは、床やカーペットに付着したあらゆるゴミやホコリを吸引することができます。',
        company: 'アンカー・ジャパン株式会社',
        url: 'https://www.ankerjapan.com/item/T2108.html'
      },
      {
        thumbnail: '/img/present07/03.png',
        name: 'ツインフィン2  マルチパーパスナイフ',
        num: '1名',
        description: '新鋼材「N 60ステンレススチール」に素材により、刃こぼれしにくく、またサビにくいのが長所です。バランス：ナイフ中央部にウエイトを配置して、より理想的な重量バランスを実現しています。デザイン：ミニマリズムをテーマに直線美を追求スタイリッシュでかっこいい高性能の包丁を使って、日々のお料理をもっとたのしく、美味しさもレベルアップ！',
        company: 'ツヴィリング J.A. ヘンケルスジャパン 株式会社',
        url: 'https://jp.zwilling-shop.com/'
      },
      {
        thumbnail: '/img/present07/04.png',
        name: '多機能シンプルリュック',
        num: '2名',
        description: '小さなお子さまとのお出かけ時には、オムツや着替え、ミルクなど、気づけば荷物の量がすごいことに。お出かけを快適にする工夫がいっぱいの多機能リュックでそんなお悩みを解決！一見ママリュックぽくないシンプルなデザイン＆カラーでパパが使ってもサマになります。',
        company: '株式会社千趣会 / ベルメゾン',
        url: 'https://www.bellemaison.jp/ep/srvlt/EPFB00/EPFB0005/dProdDtlShow?BELN_SHOP_KBN=100&KAT_BTGO=C60176_311_2020_A&SHNCRTTKKRO_KBN=03&KIKK_HBN_HYJ_KBN=t'
      },
      {
        thumbnail: '/img/present07/05.png',
        name: '福岡ぶどう（種無し巨峰4パック）5ケース（1ケース4パック入り）',
        num: '5名',
        description: '福岡県のぶどう栽培は西南暖地の特徴を生かした高品質ぶどうの生産に取り組んでいます。5月～10月の長期間にわたり美味しいぶどうをお届けするために、露地だけでなく施設栽培も行っています。種無し巨峰は小さなお子様でも簡単にお召し上がりいただけますし、ゼリーやジャムなどに加工して食べるのもおすすめです。',
        company: 'ＪＡ全農ふくれん',
        url: 'https://zennoh-fukuren.jp/'
      },
      {
        thumbnail: '/img/present07/06.png',
        name: 'ドーリーウインク　イージーラッシュ',
        num: '10名',
        description: 'さっと接着剤をつけたら、たった10秒でマツエク仕上げ。アイメイクの常識を変える 新・部分用つけまつげ「EASY LASH」。その日の気分に合わせて選べて、マスカラいらずで垢抜けアイメイクが簡単に完成します。メイクやファッションなどに合わせて、新しい毎日を楽しんでみて。',
        company: '株式会社コージー本舗',
        url: 'https://www.dollywink-jp.com/easylash/'
      }
    ]
  }),
  mounted () {
    document.title = '抽選会プレゼント一覧 - リトル・ママオンラインフェスタ'
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 60px 0 100px
.presents-wrapper
  background-color: $lightpink
  padding: 25px 0
  .presents
    .present
      margin-top: 25px
</style>
